import React from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import PageHero from '../../components/PageHero/PageHero';
import Footer from '../../components/Footer/Footer';
import LogoShowcase from './LogoShowcase';
import './AboutUs.css';

const promotersData = [
  {
    name: 'Alok Srivastava',
    image: '/images/members/alok-shrivastava.jpg',
    bio: 'Mr. Srivastava is an accomplished agribusiness professional with extensive experience in techno-commercial aspects of food and agricultural value chains. With over three decades of expertise in strategic planning, value chain development, agribusiness consulting, and food infrastructure projects, he has been instrumental in contributing to leading food and agri-business projects in India and abroad. His expertise spans across food park development, cold chain logistics, farmer producer organizations (FPOs), and agricultural market linkages.',
  },
  {
    name: 'Sunil Sihag',
    image: '/images/members/rakesh-kumar-sinha.jpg',
    bio: 'Mr. Sihag is a seasoned agribusiness professional with over two decades of experience in food processing, cold chain infrastructure, and value chain development. He has played a critical role in the feasibility assessment, enterprise development, and execution of large-scale agribusiness projects including food park development, cold storage planning, and supply chain optimization in government and private sector projects. He has successfully led and contributed to multiple national and international assignments, enhancing market linkages and post-harvest infrastructure for agricultural commodities.',
  },
  {
    name: 'Rakesh Bhushan Sinha',
    image: '/images/members/sunil-sihag.jpg',
    bio: 'Mr. Sinha has a 30 years of forestry management experience, including roles in the Indian Forest Service. Mr. Sinha specializes in natural resource management and community involvement. At the federal level, served as Joint Secretary in the Ministry of Agriculture, overseeing initiatives such as the National Mission of Sustainable Agriculture, led policy formulation efforts, including the National Agroforestry Policy and National Policy on Crop Residue Management and Sub-Mission on Agroforestry. Mr. Sinha also spearheaded flagship schemes like the Prime Minister Agriculture Irrigation Scheme, significantly increasing water use efficiency nationwide.',
  },
];

function AboutUs() {
  const ref = useRevealChildren();
  const promotersRef = useRevealChildren();

  return (
    <>
      <PageHero title="About Us" subtitle="Building resilient communities in harmony with nature" />
      <section className="aboutpage-section" ref={ref}>
        <div className="container">
          <AboutIntro />
          <VisionMissionCards />
        </div>
      </section>
      <section className="promoters-section" ref={promotersRef}>
        <div className="container">
          <Promoters />
        </div>
      </section>
      <Footer />
    </>
  );
}

function AboutIntro() {
  return (
    <div className="aboutpage-intro">
      <div className="aboutpage-logo-col reveal">
        <LogoShowcase />
      </div>
      <div className="aboutpage-text-col reveal reveal-d2">
        <div className="section-eyebrow">About Us</div>
        <h2 className="section-title">
          Stupa Developmental<br />Foundation
        </h2>
        <AboutParagraphs />
      </div>
    </div>
  );
}

function AboutParagraphs() {
  return (
    <>
      <p className="aboutpage-text">
        At STUPA Developmental Foundation, we aim to collaborate with a diverse
        range of stakeholders, including multilateral and bilateral agencies,
        national and subnational governments, civil society organizations,
        corporates, and others.
      </p>
      <p className="aboutpage-text">
        Our work spans critical areas such as Agriculture, Forestry, Livelihood
        Development, and Environmental Sustainability, focusing on impactful
        contributions in project planning, policy formulation, implementation,
        and strategic advisory.
      </p>
    </>
  );
}

function VisionMissionCards() {
  return (
    <div className="aboutpage-vm-row">
      <VMCard
        accent="sage"
        label="Our Vision"
        title="Empowering Self-Reliance"
        text="Building a future that empowers communities to achieve self-reliance, emphasizing financial and social inclusion while living in harmony with nature and the surrounding environment."
      />
      <VMCard
        accent="earth"
        label="Our Mission"
        title="Holistic Growth"
        text="To foster holistic growth through ecological amelioration and economic upliftment of all stakeholders through participatory approach."
      />
    </div>
  );
}

function VMCard({ accent, label, title, text }) {
  return (
    <div className={`aboutpage-vm-card ${accent} reveal`}>
      <span className="aboutpage-vm-label">{label}</span>
      <h3 className="aboutpage-vm-title">{title}</h3>
      <p className="aboutpage-vm-text">{text}</p>
    </div>
  );
}

function Promoters() {
  return (
    <div className="promoters-wrapper">
      <div className="section-eyebrow reveal">Leadership</div>
      <h2 className="section-title reveal">Promoters</h2>
      <div className="promoters-grid">
        {promotersData.map((promoter, index) => (
          <PromoterCard key={promoter.name} promoter={promoter} index={index} />
        ))}
      </div>
    </div>
  );
}

function PromoterCard({ promoter, index }) {
  return (
    <div className={`promoter-card reveal reveal-d${index + 1}`}>
      <div className="promoter-image-wrapper">
        <img
          src={promoter.image}
          alt={promoter.name}
          className="promoter-image"
          loading="lazy"
        />
        <div className="promoter-image-overlay" />
      </div>
      <div className="promoter-info">
        <h3 className="promoter-name">{promoter.name}</h3>
        <p className="promoter-bio">{promoter.bio}</p>
      </div>
    </div>
  );
}

export default AboutUs;
